import fetchChannel from '../fetchChannel'
import fetchWebcast from '../fetchWebcast'
import fetchSummit from '../fetchSummit'
import fetchWatchLater from '../fetchWatchLater'
import fetchRecommendations from '../fetchRecommendations'
import fetchChannelFeed from '../fetchChannelFeed'
import fetchAttendees from '../fetchAttendees'
import fetchSocialStatus from '../fetchSocialStatus'
import fetchProfile from '../fetchProfile'
import fetchWebcastCommunities from '../fetchWebcastCommunities'

type FetcherKey = 'channel' | 'webcast' | 'watchLater' | 'recommendations' | 'summit' | 'channelFeed' | 'attendees' | 'social-status' | 'user' | 'webcastCommunities'

async function fetcher (key: FetcherKey, hostUrl?: string, cloudinaryEnv?: string, channelId?: string, webcastId?: string,
  preAuthToken?: string, pageIndex?: number) {

  switch (key) {

    case 'channel':
      
      if (!channelId) return {}

      try{

        const response = await fetchChannel(channelId, hostUrl)
        return response
        
      }
      catch (e) {

        return {}

      }

    case 'webcast':

      if (!channelId || !webcastId) return {}

      try {

        const response = await fetchWebcast(channelId, webcastId, hostUrl)
        return response

      }
      catch (e) {

        return {}

      }

    case 'watchLater': {

      try {

        const response = await fetchWatchLater(hostUrl)
        return response

      } catch (e) {

        return {}
      }
      
    
    }
    case 'recommendations':

      try {
        
        const response = await fetchRecommendations(channelId, webcastId, '', hostUrl)
        return response

      }
      catch (e) {

        return []

      }

    case 'user':

    try {
      
      const response = await fetchProfile(hostUrl, cloudinaryEnv)
      return response

    }
    catch (e) {

      return {}

    }

    case 'channelFeed':
      
      if (!channelId || !webcastId) return {}

      try{

        const response = await fetchChannelFeed(channelId, webcastId, hostUrl)
        return response
        
      }
      catch (e) {

        return []

      }
    case 'attendees':

      if (!channelId || !webcastId) return null

      try{

        const response = await fetchAttendees(channelId, webcastId, pageIndex, hostUrl, cloudinaryEnv)
        return response
        
      }
      catch (e) {

        return []

      }  
      case 'webcastCommunities':

      if (!channelId || !webcastId) return null

      try{

        const response = await fetchWebcastCommunities(channelId, webcastId, hostUrl)
        return response
        
      }
      catch (e) {

        return []

      }  

    case 'social-status':

      if (!channelId || !webcastId) return null
  
        try{
  
          const response = await fetchSocialStatus(channelId, webcastId, hostUrl)
          return response
          
        }
        catch (e) {
  
          return []
  
        }  
    case 'summit':

      try {

        const response = await fetchSummit(channelId, webcastId, hostUrl)
        return response

      }
      catch (e) {

        return null

      }

    default:
      return

  }

}

export default fetcher
